export const GlobalConfig = {
  anfMax: 8
};
